import {
  Box,
  Heading,
  Link,
  SimpleGrid,
  Text,
  VStack,
} from '@chakra-ui/react';
import ContentBox from 'components/ContentBox';
import { Link as RouterLink } from 'react-router-dom';

const tools = [
  {
    title: 'Cohort Markov Fill',
    description:
      'Upload a cohort ROAS spreadsheet with missing month columns; download the triangle filled using production Markov chain prediction.',
    path: '/tooling/cohort-markov-fill',
  },
];

function ToolingHome() {
  return (
    <ContentBox>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading size="md">Tooling</Heading>
          <Text mt={2} color="gray.600" fontSize="sm">
            Internal utilities for underwriting and analytics workflows.
          </Text>
        </Box>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          {tools.map((tool) => (
            <Box
              key={tool.path}
              p={5}
              borderWidth="1px"
              borderRadius="md"
              _hover={{ borderColor: 'brand.500' }}
            >
              <Heading size="sm">{tool.title}</Heading>
              <Text mt={2} fontSize="sm" color="gray.600">
                {tool.description}
              </Text>
              <Link
                as={RouterLink}
                to={tool.path}
                mt={4}
                display="inline-block"
                color="brand.500"
                fontWeight={600}
                fontSize="sm"
              >
                Open tool
              </Link>
            </Box>
          ))}
        </SimpleGrid>
      </VStack>
    </ContentBox>
  );
}

export default ToolingHome;
